module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 financial-physical-schedule",
    staticStyle: {
      "min-width": "1155px"
    }
  }, [_c('table', {
    staticClass: "table table-condensed table-striped table-bordered"
  }, [_c('thead', [_c('tr', [(_vm.proposta.proposalPhase !== 'ANALISE' && _vm.proposta.proposalPhase !== 'PENDENTE_EM_ANALISE') ? _c('th', {
    staticClass: "ng-scope",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Atividade")]) : _vm._e(), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('th', {
    staticClass: "ng-scope",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Atividade")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Período")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.propsObjetivos), function(objetivo) {
    return [_vm._l((objetivo.goals), function(meta) {
      return [_vm._l((meta.activities), function(atividade, atividadeIndex) {
        return [_c('tr', {
          staticClass: "ng-scope",
          staticStyle: {
            "background-color": "rgb(223, 228, 235)"
          }
        }, [_c('td', {
          staticClass: "ng-binding ng-scope",
          attrs: {
            "colspan": _vm.proposta.proposalPhase === 'ANALISE' ? 5 : 4
          }
        }, [_vm._v(_vm._s(atividade.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-center ng-binding"
        }, [_vm._v(_vm._s(atividade.startPeriod))]), _vm._v(" "), _c('td', {
          staticClass: "text-center ng-binding"
        }, [_vm._v(_vm._s(atividade.finalPeriod))]), _vm._v(" "), _c('td', {
          staticClass: "text-right ng-binding",
          attrs: {
            "colspan": "3"
          }
        }, [_vm._v(_vm._s(_vm._f("real")(_vm.somaTotal(atividade.items))))]), _vm._v(" "), _c('td', {
          staticClass: "ng-scope"
        }, [_c('button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "disable": _vm.bloqueiaBotoes,
            "type": "button",
            "id": "financial-physical-activity-0"
          },
          on: {
            "click": function($event) {
              return _vm.addItem(atividade)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus-circle",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Adicionar\n                  ")])])]), _vm._v(" "), (_vm._.has(atividade, 'items') && atividade.items.length > 0) ? _c('tr', {
          staticClass: "ng-scope",
          staticStyle: {
            "background-color": "#ECF0F5",
            "font-weight": "bold"
          }
        }, [_c('th', [_vm._v("Recurso")]), _vm._v(" "), (_vm.proposta.proposalPhase !== 'PRE_ANALISE') ? _c('th', [_vm._v("Adiantável")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "width": "15%"
          }
        }, [_vm._v("Descrição Item")]), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('th', {
          staticStyle: {
            "width": "15%"
          }
        }, [_vm._v("Conta Financeira")]) : _vm._e(), _vm._v(" "), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "min-width": "55px"
          }
        }, [_vm._v("Início")]), _vm._v(" "), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "min-width": "55px"
          }
        }, [_vm._v("Fim")]), _vm._v(" "), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Quantidade")]), _vm._v(" "), _c('th', [_vm._v("Valor Unitário")]), _vm._v(" "), _c('th', [_vm._v("Valor Total")]), _vm._v(" "), _c('th', [_vm._v("Ações")])]) : _vm._e(), _vm._v(" "), _vm._l((atividade.items), function(item, itemIndex) {
          return _c('tr', {
            staticClass: "ng-scope",
            attrs: {
              "prefix": "activityItem",
              "suffix": "item.id",
              "row": "item"
            }
          }, [(!item.editando) ? [_c('td', [(item.resourceSource === 'FUNDACAO') ? _c('span', [_vm._v("\n                    Fundação\n                  ")]) : (item.resourceSource === 'CONTRAPARTIDA') ? _c('span', [_vm._v("\n                    Contrapartida\n                  ")]) : _c('span', [_vm._v("\n                    " + _vm._s(item.resourceSource) + "\n                  ")])]), _vm._v(" "), (_vm.proposta.proposalPhase !== 'PRE_ANALISE') ? _c('td', {
            staticClass: "ng-binding"
          }, [(item.foreseeable == 'false' || item.foreseeable == false || item.resourceSource === 'CONTRAPARTIDA') ? _c('span', [_vm._v("Não")]) : _c('span', [_vm._v("Sim")])]) : _vm._e(), _vm._v(" "), _c('td', {
            staticClass: "ng-binding"
          }, [_vm._v(_vm._s(item.item.type))]), _vm._v(" "), _c('td', {
            staticClass: "ng-binding"
          }, [_vm._v(_vm._s(item.item.code + '/' + item.item.description))]), _vm._v(" "), _c('td', {
            staticClass: "ng-binding"
          }, [_vm._v(_vm._s(item.itemDescription))]), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('td', {
            staticClass: "ng-binding"
          }, [_vm._v(_vm._s(item.financialAccount) + " - " + _vm._s(item.financialAccountDescription))]) : _vm._e(), _vm._v(" "), _c('td', {
            staticClass: "text-center ng-binding"
          }, [_vm._v(_vm._s(item.startPeriod))]), _vm._v(" "), _c('td', {
            staticClass: "text-center ng-binding"
          }, [_vm._v(_vm._s(item.finalPeriod))]), _vm._v(" "), _c('td', {
            staticClass: "text-center ng-binding"
          }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
            staticClass: "text-center ng-binding"
          }, [_vm._v(_vm._s(_vm._f("real")(item.unitaryValue)))]), _vm._v(" "), _c('td', {
            staticClass: "text-center ng-binding"
          }, [_vm._v(_vm._s(_vm._f("real")(item.totalValue)))]), _vm._v(" "), _c('td', [_c('i', {
            staticClass: "fa fa-edit disabled",
            staticStyle: {
              "margin-left": "5px"
            },
            attrs: {
              "id": "financial-physical-edit-item-0"
            },
            on: {
              "click": function($event) {
                _vm.bloqueiaBotoes ? null : _vm.editaItem(atividade, atividadeIndex, item, itemIndex)
              }
            }
          }), _vm._v(" "), _c('i', {
            staticClass: "fa fa-trash ng-scope",
            staticStyle: {
              "margin-left": "5px"
            },
            attrs: {
              "id": "financial-physical-delete-item-0"
            },
            on: {
              "click": function($event) {
                _vm.bloqueiaBotoes ? null : _vm.deleteItem(atividade, itemIndex)
              }
            }
          })])] : _vm._e(), _vm._v(" "), (item.editando) ? [_c('td', {
            staticStyle: {
              "padding": "0 15px",
              "margin-bottom": "10px"
            },
            attrs: {
              "colspan": "10"
            }
          }, [_c('div', {
            staticClass: "box-header with-border"
          }, [_c('h3', {
            staticClass: "box-title",
            staticStyle: {
              "color": "cornflowerblue"
            }
          }, [_vm._v(" " + _vm._s(_vm.itemForm.itemDescription))])]), _vm._v(" "), _c('div', {
            staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
            staticStyle: {
              "padding-left": "0"
            }
          }, [_c('div', {
            staticClass: "row"
          }, [_c('div', {
            staticClass: "form-group required col-md-6",
            class: {
              'has-error': _vm.errors.first('recurso')
            }
          }, [_c('label', {
            staticClass: "control-label col-md-4"
          }, [_vm._v("Recurso:")]), _vm._v(" "), _c('div', {
            staticClass: "col-md-8"
          }, [_c('select', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.itemForm.resourceSource),
              expression: "itemForm.resourceSource"
            }, {
              name: "validate",
              rawName: "v-validate",
              value: ('required'),
              expression: "'required'"
            }],
            staticClass: "form-control",
            attrs: {
              "name": "recurso",
              "aria-label": "recurso"
            },
            on: {
              "change": function($event) {
                var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                  return o.selected
                }).map(function(o) {
                  var val = "_value" in o ? o._value : o.value;
                  return val
                });
                _vm.$set(_vm.itemForm, "resourceSource", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
              }
            }
          }, [_c('option', {
            attrs: {
              "value": "FUNDACAO"
            }
          }, [_vm._v("Fundação")]), _vm._v(" "), _c('option', {
            attrs: {
              "value": "CONTRAPARTIDA"
            }
          }, [_vm._v("Contrapartida")]), _vm._v(" "), _c('option', {
            attrs: {
              "value": "PARCEIRO_ESTRATEGICO"
            }
          }, [_vm._v("P.Estratégico")])]), _vm._v(" "), (_vm.errors.first('recurso')) ? _c('span', {
            staticClass: "label label-danger"
          }, [_vm._v(" " + _vm._s(_vm.errors.first('recurso')))]) : _vm._e()])]), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE') ? _c('div', {
            staticClass: "form-group required col-md-6",
            class: {
              'has-error': _vm.errors.first('adiantavel')
            }
          }, [_c('label', {
            staticClass: "control-label col-md-4"
          }, [_vm._v("Adiantável:")]), _vm._v(" "), _c('div', {
            staticClass: "col-md-8"
          }, [_c('select', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.itemForm.foreseeable),
              expression: "itemForm.foreseeable"
            }, {
              name: "validate",
              rawName: "v-validate",
              value: ('required'),
              expression: "'required'"
            }],
            staticClass: "form-control",
            attrs: {
              "disabled": _vm.itemForm.resourceSource === 'CONTRAPARTIDA',
              "name": "adiantavel",
              "required": ""
            },
            on: {
              "change": function($event) {
                var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                  return o.selected
                }).map(function(o) {
                  var val = "_value" in o ? o._value : o.value;
                  return val
                });
                _vm.$set(_vm.itemForm, "foreseeable", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
              }
            }
          }, [_c('option', {
            attrs: {
              "value": "false"
            }
          }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
            attrs: {
              "value": "true"
            }
          }, [_vm._v("Sim")])]), _vm._v(" "), (_vm.errors.first('adiantavel')) ? _c('span', {
            staticClass: "label label-danger"
          }, [_vm._v(" " + _vm._s(_vm.errors.first('adiantavel')))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
            staticClass: "row"
          }, [_c('div', {
            staticClass: "form-group required col-md-6",
            class: {
              'has-error': _vm.errors.first('tipo do recurso')
            }
          }, [_c('label', {
            staticClass: "control-label col-md-4"
          }, [_vm._v("Tipo:")]), _vm._v(" "), _c('div', {
            staticClass: "col-md-8"
          }, [_c('div', [_c('select', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.itemForm.item.type),
              expression: "itemForm.item.type"
            }, {
              name: "validate",
              rawName: "v-validate",
              value: ('required'),
              expression: "'required'"
            }],
            staticClass: "form-control",
            attrs: {
              "name": "tipo do recurso",
              "aria-label": "tipo recurso"
            },
            on: {
              "change": [function($event) {
                var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                  return o.selected
                }).map(function(o) {
                  var val = "_value" in o ? o._value : o.value;
                  return val
                });
                _vm.$set(_vm.itemForm.item, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
              }, _vm.buscaItems]
            }
          }, [_c('option', {
            attrs: {
              "value": "PRODUTO"
            }
          }, [_vm._v("Produto")]), _vm._v(" "), _c('option', {
            attrs: {
              "value": "SERVICO"
            }
          }, [_vm._v("Serviço")])])]), _vm._v(" "), (_vm.errors.first('tipo do recurso')) ? _c('span', {
            staticClass: "label label-danger"
          }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo do recurso')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
            staticClass: "form-group required col-md-6",
            class: {
              'has-error': _vm.errors.first('item')
            }
          }, [_c('label', {
            staticClass: "control-label col-md-4"
          }, [_vm._v("Item:")]), _vm._v(" "), _c('div', {
            staticClass: "col-md-8"
          }, [_c('div', {
            attrs: {
              "approval": "finPhySchFormCtrl.approval",
              "state": "finPhySchFormCtrl.approvalState"
            }
          }, [_c('multiselect', {
            directives: [{
              name: "validate",
              rawName: "v-validate",
              value: ('required'),
              expression: "'required'"
            }],
            attrs: {
              "name": "item",
              "custom-label": _vm.itemCodigo,
              "options": _vm.items,
              "close-on-select": true,
              "hide-selected": true,
              "preserve-search": false,
              "placeholder": "Escolha um item",
              "label": "description",
              "track-by": "code",
              "preselect-first": true
            },
            on: {
              "open": _vm.buscaItems
            },
            scopedSlots: _vm._u([{
              key: "option",
              fn: function(props) {
                return [_c('div', {
                  staticClass: "option__desc"
                }, [_c('span', {
                  staticClass: "option__title"
                }, [_vm._v(_vm._s(props.option.code) + " / " + _vm._s(props.option.description))])])]
              }
            }], null, true),
            model: {
              value: (_vm.itemForm.item),
              callback: function($$v) {
                _vm.$set(_vm.itemForm, "item", $$v)
              },
              expression: "itemForm.item"
            }
          })], 1), _vm._v(" "), (_vm.errors.first('item')) ? _c('span', {
            staticClass: "label label-danger"
          }, [_vm._v(" " + _vm._s(_vm.errors.first('item')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
            staticClass: "row"
          }, [_c('div', {
            staticClass: "form-group required col-md-6",
            class: {
              'has-error': _vm.errors.first('descrição item')
            }
          }, [_c('label', {
            staticClass: "control-label col-md-4"
          }, [_vm._v("Descrição Item:")]), _vm._v(" "), _c('div', {
            staticClass: "col-md-8"
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.itemForm.itemDescription),
              expression: "itemForm.itemDescription"
            }, {
              name: "validate",
              rawName: "v-validate",
              value: ('required'),
              expression: "'required'"
            }],
            staticClass: "form-control",
            attrs: {
              "type": "text",
              "name": "descrição item",
              "maxlength": "255",
              "aria-label": "Descrição do item"
            },
            domProps: {
              "value": (_vm.itemForm.itemDescription)
            },
            on: {
              "input": function($event) {
                if ($event.target.composing) { return; }
                _vm.$set(_vm.itemForm, "itemDescription", $event.target.value)
              }
            }
          })]), _vm._v(" "), (_vm.errors.first('descrição item')) ? _c('span', {
            staticClass: "label label-danger"
          }, [_vm._v(" " + _vm._s(_vm.errors.first('descrição item')))]) : _vm._e()])]), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('div', {
            staticClass: "form-group required col-md-6",
            class: {
              'has-error': _vm.errors.first('conta financeira')
            }
          }, [_c('label', {
            staticClass: "control-label col-md-4"
          }, [_vm._v("Conta Financeira:")]), _vm._v(" "), _c('div', {
            staticClass: "col-md-8"
          }, [_c('multiselect', {
            directives: [{
              name: "validate",
              rawName: "v-validate",
              value: ('required'),
              expression: "'required'"
            }],
            attrs: {
              "name": "conta financeira",
              "custom-label": _vm.itemCodigo,
              "options": _vm.contasFinanceiras,
              "close-on-select": true,
              "hide-selected": true,
              "preserve-search": false,
              "placeholder": "Escolha um item",
              "label": "description",
              "track-by": "code",
              "preselect-first": false
            },
            on: {
              "select": _vm.selecionaConta,
              "close": function($event) {
                delete this.itemForm.financialAccountObject
              }
            },
            scopedSlots: _vm._u([{
              key: "option",
              fn: function(props) {
                return [_c('div', {
                  staticClass: "option__desc"
                }, [_c('span', {
                  staticClass: "option__title"
                }, [_vm._v(_vm._s(props.option.code) + " / " + _vm._s(props.option.description))])])]
              }
            }], null, true),
            model: {
              value: (_vm.financialAccountObject),
              callback: function($$v) {
                _vm.financialAccountObject = $$v
              },
              expression: "financialAccountObject"
            }
          }), _vm._v(" "), (_vm.errors.first('conta financeira')) ? _c('span', {
            staticClass: "label label-danger"
          }, [_vm._v(" " + _vm._s(_vm.errors.first('conta financeira')))]) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
            staticClass: "row"
          }, [_c('div', {
            staticClass: "form-group required col-md-6",
            class: {
              'has-error': _vm.errors.first('inicio')
            }
          }, [_c('label', {
            staticClass: "control-label col-md-4"
          }, [_vm._v("Início:")]), _vm._v(" "), _c('div', {
            staticClass: "col-md-8"
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.itemForm.startPeriod),
              expression: "itemForm.startPeriod"
            }, {
              name: "validate",
              rawName: "v-validate",
              value: ('required'),
              expression: "'required'"
            }],
            staticClass: "form-control text-right",
            attrs: {
              "type": "number",
              "name": "inicio",
              "maxlength": "2",
              "aria-label": "Inicio do período",
              "min": atividade.startPeriod,
              "max": atividade.finalPeriod,
              "ng-change": "finPhySchFormCtrl.onChangePeriod(finPhySchForm.startPeriod, finPhySchForm.finalPeriod)"
            },
            domProps: {
              "value": (_vm.itemForm.startPeriod)
            },
            on: {
              "input": function($event) {
                if ($event.target.composing) { return; }
                _vm.$set(_vm.itemForm, "startPeriod", $event.target.value)
              }
            }
          })]), _vm._v(" "), (_vm.errors.first('inicio')) ? _c('span', {
            staticClass: "label label-danger"
          }, [_vm._v(" " + _vm._s(_vm.errors.first('inicio')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
            staticClass: "form-group required col-md-6",
            class: {
              'has-error': _vm.errors.first('fim')
            }
          }, [_c('label', {
            staticClass: "control-label col-md-4"
          }, [_vm._v("Fim:")]), _vm._v(" "), _c('div', {
            staticClass: "col-md-8"
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.itemForm.finalPeriod),
              expression: "itemForm.finalPeriod"
            }, {
              name: "validate",
              rawName: "v-validate",
              value: ('required'),
              expression: "'required'"
            }],
            staticClass: "form-control text-right",
            attrs: {
              "type": "number",
              "name": "fim",
              "maxlength": "2",
              "aria-label": "Fim do período",
              "min": atividade.startPeriod,
              "max": atividade.finalPeriod
            },
            domProps: {
              "value": (_vm.itemForm.finalPeriod)
            },
            on: {
              "input": function($event) {
                if ($event.target.composing) { return; }
                _vm.$set(_vm.itemForm, "finalPeriod", $event.target.value)
              }
            }
          })]), _vm._v(" "), (_vm.errors.first('fim')) ? _c('span', {
            staticClass: "label label-danger"
          }, [_vm._v(" " + _vm._s(_vm.errors.first('fim')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
            staticClass: "row"
          }, [_c('div', {
            staticClass: "form-group required col-md-6",
            class: {
              'has-error': _vm.errors.first('quantidade')
            }
          }, [_c('label', {
            staticClass: "control-label col-md-4"
          }, [_vm._v("Quantidade:")]), _vm._v(" "), _c('div', {
            staticClass: "col-md-8"
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.itemForm.quantity),
              expression: "itemForm.quantity"
            }, {
              name: "validate",
              rawName: "v-validate",
              value: ('required'),
              expression: "'required'"
            }],
            staticClass: "form-control text-right",
            attrs: {
              "type": "number",
              "name": "quantidade",
              "min": "1",
              "maxlength": "6",
              "aria-label": "Quantidade do recurso"
            },
            domProps: {
              "value": (_vm.itemForm.quantity)
            },
            on: {
              "change": function($event) {
                return _vm.valorTotal(_vm.itemForm)
              },
              "input": function($event) {
                if ($event.target.composing) { return; }
                _vm.$set(_vm.itemForm, "quantity", $event.target.value)
              }
            }
          })]), _vm._v(" "), (_vm.errors.first('quantidade')) ? _c('span', {
            staticClass: "label label-danger"
          }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
            staticClass: "form-group required col-md-6",
            class: {
              'has-error': _vm.errors.first('valor unitario')
            }
          }, [_c('label', {
            staticClass: "control-label col-md-4"
          }, [_vm._v("Valor Unitário:")]), _vm._v(" "), _c('div', {
            staticClass: "col-md-8"
          }, [_c('div', [_c('money', {
            directives: [{
              name: "validate",
              rawName: "v-validate",
              value: ('required|min_value:1'),
              expression: "'required|min_value:1'"
            }],
            staticClass: "form-control text-right",
            attrs: {
              "name": "valor unitario"
            },
            on: {
              "change": function($event) {
                return _vm.valorTotal(_vm.itemForm)
              }
            },
            model: {
              value: (_vm.itemForm.unitaryValue),
              callback: function($$v) {
                _vm.$set(_vm.itemForm, "unitaryValue", $$v)
              },
              expression: "itemForm.unitaryValue"
            }
          })], 1), _vm._v(" "), (_vm.errors.first('valor unitario')) ? _c('span', {
            staticClass: "label label-danger"
          }, [_vm._v(" " + _vm._s(_vm.errors.first('valor unitario')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
            staticClass: "form-group",
            staticStyle: {
              "margin-bottom": "0"
            }
          }, [_c('div', {
            staticClass: "col-md-8 col-md-offset-4"
          }, [_c('button', {
            staticClass: "btn btn-primary btn-flat",
            attrs: {
              "type": "button",
              "id": "financial-physical-save-item"
            },
            on: {
              "click": function($event) {
                return _vm.onAdd(atividade, item, itemIndex)
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-check",
            attrs: {
              "aria-hidden": "true"
            }
          }), _vm._v(" Ok\n                          ")]), _vm._v(" "), _c('span', {
            staticClass: "btn btn-default btn-flat",
            attrs: {
              "type": "button",
              "id": "financial-physical-cancel-item"
            },
            on: {
              "~click": function($event) {
                return _vm.cancelaItem(atividade, item, itemIndex)
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-times-circle",
            attrs: {
              "aria-hidden": "true"
            }
          }), _vm._v(" Cancelar\n                        ")])])])])])] : _vm._e()], 2)
        })]
      })]
    })]
  })], 2), _vm._v(" "), _c('tfoot', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('tr', {
    staticClass: "ng-scope",
    attrs: {
      "ng-if": "finPhySchFormCtrl.showApprovalField != 'TRUE'"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Total Fundação")]), _vm._v(" "), _c('td', {
    staticClass: "text-right ng-binding",
    staticStyle: {
      "border-left": "none"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalFundacao())))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
    staticClass: "ng-scope",
    attrs: {
      "ng-if": "finPhySchFormCtrl.showApprovalField != 'TRUE'"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Total Contrapartida")]), _vm._v(" "), _c('td', {
    staticClass: "text-right ng-binding",
    staticStyle: {
      "border-left": "none"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalContraPartida())))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
    staticClass: "ng-scope",
    attrs: {
      "ng-if": "finPhySchFormCtrl.showApprovalField != 'TRUE'"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Total do Projeto")]), _vm._v(" "), _c('td', {
    staticClass: "text-right ng-binding",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalFundacao() + _vm.totalContraPartida())))]), _vm._v(" "), _c('td')])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7828cc39!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/cronogramaOld.vue
// module id = 2022
// module chunks = 1